import { useEffect } from 'react';

const MOUSEDOWN = 'mousedown';
const TOUCHSTART = 'touchstart';

type HandledEvents = [typeof MOUSEDOWN, typeof TOUCHSTART];
type HandledEventsType = HandledEvents[number];
type PossibleEvent = {
  [Type in HandledEventsType]: HTMLElementEventMap[Type];
}[HandledEventsType];
type Handler = (event: PossibleEvent) => void;

export const useOnClickOutside = (
  ref: React.RefObject<HTMLElement | null>,
  handler: Handler | null,
) => {
  useEffect(() => {
    // checkVisibility is not supported on all browsers
    // Bsahtek JF for this tip <3
    const isComponentVisible =
      typeof (ref.current as any)?.checkVisibility === 'function'
        ? (ref.current as any)?.checkVisibility()
        : !!(
            ref.current?.offsetWidth ||
            ref.current?.offsetHeight ||
            ref.current?.getClientRects().length
          );

    if (!handler || !isComponentVisible) {
      return;
    }

    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};
